import './util/global.css';

import { detect } from 'detect-browser';
import React from 'react';
import { ApolloProvider } from 'react-apollo-hooks';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import ErrorDisplay from './components/error';
import App from './containers/App/App';
import { client } from './store/store';

// import "./util/font/font.css";
const browser = detect();

client.writeData({
  data: {
    app: {
      __typename: "AppSetting",
      browser: browser!.name,
    },
  },
});

ReactDOM.render(
  <ApolloProvider client={client}>
    {browser!.name === "samsung" ? (
      // FIX : 삼성브라우저 불가 안내 페이지를 만드세요.
      <ErrorDisplay
        message={
          "삼성 브라우저를 지원하지 않습니다. 크롬으로 실행부탁드립니다."
        }
      />
    ) : (
      <Router>
        <Route
          exact={true}
          path="/"
          render={() => {
            return (
              <ErrorDisplay
                message={"정확한 URL 주소를 입력해 주셔야 합니다."}
              />
            );
          }}
        />
        <Route exact={true} path="/:ordno" component={App} />
      </Router>
    )}
  </ApolloProvider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.tsx